/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {PropertyEmailOption} from './PropertyEmailOption';

/**
 * The PropertyOptions model module.
 * @module model/PropertyOptions
 * @version 1.0.0
 */
export class PropertyOptions {
  /**
   * Constructs a new <code>PropertyOptions</code>.
   * @alias module:model/PropertyOptions
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PropertyOptions</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PropertyOptions} obj Optional instance to populate.
   * @return {module:model/PropertyOptions} The populated <code>PropertyOptions</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PropertyOptions();
      if (data.hasOwnProperty('emails'))
        obj.emails = ApiClient.convertToType(data['emails'], [PropertyEmailOption]);
    }
    return obj;
  }
}

/**
 * @member {Array.<module:model/PropertyEmailOption>} emails
 */
PropertyOptions.prototype.emails = undefined;

